<template>
    <section class="module-configurateur-produit">

        <h2 class="titre">
            Votre Réservation
        </h2>

        <transition mode="out-in">
            <div class="wrapper" key="confirm-message" v-if="submitted">

                <div class="cruise-complete" v-if="!optionSended">
                    <p>
                        <span class="icon-aside-valid"></span>
                    </p>
                    <p><strong>Votre réservation a bien été configurée.</strong></p>
                    <p>
                        Vous allez être redirigé vers la page de paiement
                        dans {{ countdown }} seconde{{ countdown > 1 ? 's' : '' }}.<br>
                        <a :href="cartUrl">Cliquez ici</a> si la redirection ne s'effectue pas.
                    </p>
                </div>

                <div class="cruise-complete" v-if="optionSended && optionSendedOK">
                    <p>
                        <span class="icon-aside-valid"></span>
                    </p>
                    <p><strong>Vous venez de poser une option pour un voyage.</strong></p>
                    <p>Pour retrouver votre voyage, rendez-vous sur votre espace dans la rubrique <a :href="wc_dash_order">Mes réservations</a></p>
                </div>


                <div class="cruise-complete" v-if="optionSended && !optionSendedOK">
                    <div class="loader-spin">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <p><strong>Traitement en cours</strong></p>
                </div>

            </div>

            <div class="wrapper" key="configurator" :class="{bleu: currentStep === 3}" v-else>
                <div class="bg-darkweb"></div>
                <div class="wrap-aside" @click.self="closeArianeMobile()">
                    <div class="ariane-mobile"
                         :class="{open: arianeMobileOpen}"
                         @click="toggleArianeMobile()">
                        {{ arianeMobile }}
                    </div>
                    <aside :class="{open: arianeMobileOpen}">
                        <header>
                            Étapes de réservation
                        </header>

                        <div v-for="(step, i) in steps" :class="stepTitleClasses(i)">
                            <p class="titre-etape">{{ i + 1 }}. {{ step.label }}</p>
                            <!-- Step 1 -->
                            <p class="valid" v-if="i === 0 && step.completed">
                                <a href="#" class="modifier" @click.prevent="editCabinCount()">- Modifier</a>
                            </p>
                            <!-- Step 2 -->
                            <ul v-else-if="i === 1">
                                <li v-for="(value, cabinIndex) in cabinCount" :class="cabinTitleClasses(cabinIndex)">
                                    <p :class="{valid: form.cabins[cabinIndex]}">
                                        {{ roomLabel }} {{ value }}
                                        <a href="#"
                                           class="modifier"
                                           @click.prevent="editCabin(cabinIndex)"
                                           v-if="showEditCabin(cabinIndex)">
                                            - Modifier
                                        </a>
                                    </p>
                                    <p class="nom-cabine" v-if="form.cabins[cabinIndex]">
                                        {{ form.cabins[cabinIndex].type.label }}
                                    </p>
                                </li>
                            </ul>
                            <!-- Step 3 -->
                            <ul v-else-if="i === 2">
                                <li v-for="(cabin, cabinIndex) in form.cabins">
                                    <p>{{ roomLabel }} {{ cabinIndex + 1 }}</p>
                                    <ul>
                                        <li v-for="(traveler, travelerIndex) in cabin.seats">
                                            <p class="num-voyageur"
                                               :class="travelerClasses(cabin, cabinIndex, travelerIndex)">
                                                Voyageur {{ traveler }}
                                                <template v-if="cabin.travelers[travelerIndex]">
                                                    ({{ cabin.travelers[travelerIndex].lastName }}
                                                    {{ cabin.travelers[travelerIndex].firstName }})
                                                </template>
                                                <a href="#"
                                                   class="modifier"
                                                   @click.prevent="editTraveler(cabinIndex, travelerIndex)"
                                                   v-if="cabin.travelers[travelerIndex]">
                                                    - Modifier
                                                </a>
                                            </p>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>

                    </aside>
                </div>

                <transition name="component-fade" mode="out-in" @after-leave="ctaAfterStepChange()">
                    <keep-alive exclude="cruise-complete">
                        <trip-booking :dates="dates"
                                      :contactFormUrl="cruise.contactFormUrl"
                                      @complete="onBookingComplete"
                                      v-if="currentStep === 0">
                        </trip-booking>
                        <cabin-select v-for="(value, i) in cabinCount"
                                      v-if="currentStep === 1 && currentCabinIndex === i"
                                      :cabin-index="i"
                                      :key="`cabin_select_${i}`"
                                      :available-cabins="cabins"
                                      :form="form.cabins"
                                      :is-circuit="cruise.is_circuit"
                                      @selected="onCabinSelected">
                        </cabin-select>
                        <template v-for="(cabin, cabinIndex) in form.cabins"
                                  v-if="currentStep === 2 && currentTravelerCabinIndex === cabinIndex">
                            <traveler-info v-for="(traveler, travelerIndex) in cabin.seats"
                                           v-if="travelerIndex === currentTravelerIndex"
                                           :min-passport-validity-date="selectedDate.passport_min_valid_date"
                                           :cruise-end-date="selectedDate.end_date"
                                           :cabin-index="cabinIndex"
                                           :traveler-index="travelerIndex"
                                           :addons="addons"
                                           :insurances="insurances"
                                           :options="options"
                                           :selected-date="selectedDate"
                                           :is-circuit="cruise.is_circuit"
                                           :form="form"
                                           :all-travelers="allTravelers"
                                           :passport-required="cruise.passport_required"
                                           :key="`cabin_${cabinIndex}_traveler_${travelerIndex}`"
                                           @clean-travelers="removeTravelersAfterIndex"
                                           @completed="onTravelerInfosCompleted($event, cabinIndex, travelerIndex)">
                            </traveler-info>
                        </template>
                        <cruise-complete v-if="currentStep === 3"
                                         :loading="loading"
                                         :cruise="cruise"
                                         :selectedDateIndex="selectedDateIndex"
                                         :form="form"
                                         @submit="submit"
                                         @option="requestOption">
                        </cruise-complete>
                    </keep-alive>
                </transition>
            </div>
        </transition>

    </section>
</template>

<script>
    import $ from 'jquery';
    import {debounce, mapKeys, mapValues, snakeCase, findIndex, forEach, sumBy} from 'lodash';
    import {DateTime} from 'luxon';
    import ScrollMagic from 'scrollmagic';
    import app from '../../app';
    import {breakpointDown, breakpointUp, breakpointOnly} from '../../libs/Breakpoints';
    import ScrollMagicGE from '../../libs/ScrollMagicGE';
    import ajaxForm from '../../mixins/ajaxForm';
    import CabinSelect from './CabinSelect';
    import CruiseComplete from './CruiseComplete';
    import TravelerInfo from './TravelerInfo';
    import TripBooking from './TripBooking';
    import Scrolling from '../../libs/Scrolling';
    import Modal from '../../libs/Modal';
    import saveState from '../../libs/save-state';

    let leavingWarningActive = false;
    let configuratorTopPosition = 0;

    function getTopPosition(element) {
        return element.getBoundingClientRect().top + window.pageYOffset;
    }

    export default {
        components: {TripBooking, CabinSelect, TravelerInfo, CruiseComplete},
        mixins: [ajaxForm, saveState],
        props: {
            cruise: {
                type: Object,
                required: true,
            },
        },
        data: context => ({
            currentStep: 0,
            currentCabinIndex: 0,
            currentTravelerCabinIndex: 0,
            currentTravelerIndex: 0,
            cabinCount: 0,
            steps: [
                {
                    label: 'Réserver votre voyage',
                    completed: false,
                },
                {
                    label: `Choix ${context.cruise.is_circuit ? 'chambre' : 'cabine'}(s)`,
                    completed: false,
                },
                {
                    label: 'Voyageur(s)',
                    completed: false,
                },
                {
                    label: 'Récapitulatif',
                    completed: false,
                },
            ],
            form: {
                cabins: [],
                tripDates: null,
            },
            arianeMobileOpen: false,
            cruiseConfiguratorArianeScene: null,
            ScrollDuration: 0,
            cartUrl: window.GrandsEspaces.cartUrl,
            countdown: 3,
            optionGeneveStatusOk: false,
            optionSended: false,
            optionSendedOK: false,
        }),
        computed: {
            wc_dash_order(){
              return window.GrandsEspaces.wc_account_order_permalink
            },
            dates() {
                return this.cruise.dates.map(date => {
                    return {
                        start: DateTime.fromISO(date.start_date),
                        end: DateTime.fromISO(date.end_date),
                    };
                });
            },
            selectedDate() {
                if (!this.form.tripDates) {
                    return null;
                }

                return this.cruise.dates.find(date => {
                    return DateTime.fromISO(date.start_date).equals(this.form.tripDates.start) &&
                        DateTime.fromISO(date.end_date).equals(this.form.tripDates.end);
                });
            },
            selectedDateIndex() {
                if (!this.form.tripDates) {
                    return null;
                }

                return findIndex(this.cruise.dates, date => {
                    return DateTime.fromISO(date.start_date).equals(this.form.tripDates.start) &&
                        DateTime.fromISO(date.end_date).equals(this.form.tripDates.end);
                });
            },
            cabins() {
                return this.selectedDate ? this.selectedDate.cabins : [];
            },
            addons() {
                return this.selectedDate ? this.selectedDate.addons : [];
            },
            insurances() {
                return this.selectedDate ? this.selectedDate.insurances : [];
            },
            options() {
                return this.selectedDate ? this.selectedDate.options : [];
            },
            allStepsCompleted() {
                return this.steps.reduce((completed, step) => completed && step.completed, true);
            },
            arianeMobile() {
                if (this.currentStep === 0) {
                    return '1. Réserver votre voyage';
                }
                if (this.currentStep === 1) {
                    return `2. Choix ${this.roomLabel}(s) > ${this.roomLabel} ${this.currentCabinIndex + 1}`;
                }
                if (this.currentStep === 2) {
                    return `3. ${this.roomLabel} ${this.currentTravelerCabinIndex + 1} > Voyageur ${this.currentTravelerIndex + 1}`;
                }
                if (this.currentStep === 3) {
                    return `4. Récapitulatif`;
                }
            },
            roomLabel() {
                return this.cruise.is_circuit ? 'chambre' : 'cabine';
            },
            allTravelers() {
                let all_travelers = [];
                forEach(this.form.cabins, (cabin, key) => {

                    forEach(cabin.travelers, (traveler, key) => {
                        all_travelers.push(traveler);
                    });

                });
                return all_travelers;
            }
        },
        methods: {
            getSaveStateConfig() {
                return {
                    'cacheKey': 'CruiseConfigurator',
                    'saveProperties': ['form', 'cruise'],
                };
            },
            stepTitleClasses(i) {
                return [
                    'bloc-etape',
                    `etape-${i + 1}`,
                    {
                        active: this.currentStep === i,
                        disabled: this.currentStep < i,
                    },
                ];
            },
            cabinTitleClasses(i) {
                return {
                    active: this.currentStep === 1 && this.currentCabinIndex === i,
                    disabled: !this.form.cabins[i] && this.currentCabinIndex !== i,
                    valid: this.form.cabins[i] && this.currentCabinIndex !== i,
                };
            },
            travelerClasses(cabin, cabinIndex, travelerIndex) {
                let active = this.currentStep === 2 && cabinIndex === this.currentTravelerCabinIndex && travelerIndex === this.currentTravelerIndex;
                let valid = cabin.travelers[travelerIndex];

                return {active, valid, disabled: !active && !valid};
            },
            goToStep(index) {

                forEach(this.steps, (step, i) => {

                    if (i >= index) {
                        this.steps[i].completed = false;
                    }

                });

                this.currentStep = index;

                this.closeArianeMobile();
            },
            nextStep() {
                this.steps[this.currentStep].completed = true;
                // let step = 0;
                // for (step; step < this.steps.length && this.steps[step].completed; step++) ;
                // this.currentStep = step;

                this.currentTravelerCabinIndex = 0;
                this.currentTravelerIndex = 0;
                this.currentStep = this.currentStep + 1;


            },
            showEditCabin(cabinIndex) {
                return this.form.cabins[cabinIndex] && (this.currentStep !== 1 || this.currentCabinIndex !== cabinIndex);
            },
            editCabinCount() {
                this.goToStep(0);
                this.form.cabins.length = 0;
                this.cabinCount = 0;
                this.currentCabinIndex = 0;
                this.currentTravelerCabinIndex = 0;
                this.currentTravelerIndex = 0;
            },
            editCabin(index) {
                this.form.cabins.length = index;
                this.goToStep(1);
                this.currentCabinIndex = index;
                this.closeArianeMobile();
            },
            onBookingComplete({cabinCount, tripDates}) {
                leavingWarningActive = true;
                // If the user change the cabin count, remove the excess cabins
                if (cabinCount < this.cabinCount) {
                    this.form.cabins.splice(cabinCount, this.cabinCount - cabinCount);
                } else if (cabinCount > this.cabinCount) {
                    this.steps[1].completed = false;
                }
                this.cabinCount = cabinCount;
                this.form.tripDates = tripDates;
                this.nextStep();
                // this.nextCabin();

            },
            onCabinSelected(cabin) {
                this.$set(this.form.cabins, this.currentCabinIndex, cabin);
                this.cleanTravelersLengthOnCabin();
                this.nextCabin();

            },
            cleanTravelersLengthOnCabin() {

                forEach(this.form.cabins, (cabin, i) => {
                    if (cabin.book_all) {
                        this.form.cabins[i].travelers.length = 1;
                    }
                });

            },
            nextCabin() {
                for (let i = 0; i < this.cabinCount; i++) {
                    if (!this.form.cabins[i]) {
                        this.currentCabinIndex = i;
                        return;
                    }
                }

                if (this.form.cabins.length === this.cabinCount) {
                    this.nextStep();
                }


            },
            nextTravelerIndexes() {
                let cabinIndex, travelerIndex;

                for (cabinIndex = 0; cabinIndex < this.form.cabins.length; cabinIndex++) {
                    let cabin = this.form.cabins[cabinIndex];

                    for (travelerIndex = 0; travelerIndex < cabin.seats; travelerIndex++) {

                        if (cabin.travelers[travelerIndex] === undefined) {
                            return {cabinIndex, travelerIndex, completed: false};
                        }
                    }

                }

                return {cabinIndex, travelerIndex, completed: true};
            },
            nextTraveler() {
                let indexes = this.nextTravelerIndexes();
                this.currentTravelerCabinIndex = indexes.cabinIndex;
                this.currentTravelerIndex = indexes.travelerIndex;

                if (indexes.completed === true) {
                    this.checkGeneve();
                }

                if (indexes.completed === true && this.optionGeneveStatusOk) {
                    this.nextStep();
                }


            },
            checkGeneve() {

                if (!this.selectedDate.option_geneve) {
                    this.optionGeneveStatusOk = true;
                    return;
                }

                let duoCount = sumBy(this.allTravelers, function (traveler) {

                    if (traveler.geneve === 'duo') {
                        return 1;
                    } else {
                        return 0;
                    }

                });

                if (duoCount % 2 === 0) {
                    this.optionGeneveStatusOk = true;
                }
                else {
                    this.openModalGeneveAlert();
                    this.optionGeneveStatusOk = false;
                }

                this.currentTravelerCabinIndex = 0;
                this.currentTravelerIndex = 0;

            },
            openModalGeneveAlert() {
                Modal.showModal("#modal-geneve-alert");
            },
            editTraveler(cabinIndex, travelerIndex) {
                this.goToStep(2);
                this.currentTravelerCabinIndex = cabinIndex;
                this.currentTravelerIndex = travelerIndex;
                this.closeArianeMobile();
            },
            removeTravelersAfterIndex() {

                let nextIndex = this.currentTravelerCabinIndex + 1;

                // Clean higher Cabins
                for (var i = nextIndex; i < this.form.cabins.length; i++) {
                    this.form.cabins[i].travelers.length = 0;
                }

                // Clean Self index Cabin
                this.form.cabins[this.currentTravelerCabinIndex].travelers.length = this.currentTravelerIndex + 1;

                this.$forceUpdate();

            },
            onTravelerInfosCompleted(traveler, cabinIndex, travelerIndex) {
                this.$set(this.form.cabins[cabinIndex].travelers, travelerIndex, traveler);
                this.nextTraveler();
            },
            getSendingFOrm(takeOption = false) {
                return {
                    cruise_id: this.cruise.id,
                    trip_dates: {
                        start: this.form.tripDates.start.toISODate(),
                        end: this.form.tripDates.end.toISODate(),
                    },
                    cabins: this.form.cabins.map(({index, seats, book_all, type, travelers}) => ({
                        index,
                        seats,
                        book_all: Number(book_all),
                        type: type.id,
                        travelers: travelers.map(traveler => mapValues(
                            mapKeys(
                                traveler,
                                (value, key) => snakeCase(key),
                            ),
                            value => typeof value === 'boolean' ? Number(value) : value,
                            )
                        ).map(traveler => {
                            if (traveler.birth_date) {
                                traveler.birth_date = DateTime.fromFormat(traveler.birth_date, "dd/MM/yyyy").toISODate();

                            }
                            if (traveler.passport_validity_date) {
                                traveler.passport_validity_date = DateTime.fromFormat(traveler.passport_validity_date, "dd/MM/yyyy").toISODate();
                            }
                            return traveler;
                        }),
                    })),
                    take_option: Number(takeOption),
                };
            },
            submit() {
                this.ctaAfterStepChange();
                return this.request('ge_add_product_to_cart', this.getSendingFOrm()
                ).then(response => {
                    leavingWarningActive = false;
                    app.cart = response.data.cart;
                    this.startCountdown();
                });
            },
            requestOption() {

                if (this.$root.user === null) {
                    leavingWarningActive = false;
                    this.saveState(this.getSendingFOrm(true));

                    // not logged
                    this.$root.$refs['login-panel'].isoption = true;
                    Modal.showModal('#loginpanel');
                    return null;
                }

                this.ctaAfterStepChange();

                return this.request('ge_add_product_to_cart', this.getSendingFOrm(true),
                    {
                        withCredentials: true
                    }
                ).then(response => {
                    leavingWarningActive = false;
                    this.optionSended = true;
                    this.optionSendedOK = true;
                    // app.cart = response.data.cart;
                    // this.startCountdown();
                });


            },
            saveCruiseToOption() {
                this.ctaAfterStepChange();

                this.request('ge_add_product_to_cart', this.getLocalStorageData(),
                    {
                        withCredentials: true
                    }
                ).then(response => {
                    leavingWarningActive = false;
                    this.optionSended = true;
                    this.optionSendedOK = true;
                    let query = Object.assign({}, this.$route.query);
                    delete query.is_option;
                    this.$router.replace({query});
                    // app.cart = response.data.cart;
                    // this.startCountdown();
                });

            },
            toggleArianeMobile() {
                if (breakpointDown('md')) {
                    if (!this.arianeMobileOpen) {
                        $(this.$el).find('.wrap-aside').css('height', '100vh');
                        $(this.$el).find('.bg-darkweb').fadeIn(400);
                        this.arianeMobileOpen = true;
                    } else {
                        this.closeArianeMobile();
                    }
                }
            },
            closeArianeMobile() {
                this.arianeMobileOpen = false;
                $(this.$el).find('.bg-darkweb').fadeOut(100);
                let close = debounce(() => {
                    if (!this.arianeMobileOpen) {
                        $(this.$el).find('.wrap-aside').css('height', 'auto');
                    }
                }, 400);
                close();
            },
            cruiseConfiguratorAriane() {
                this.ScrollDuration = $('.module-configurateur-produit .wrapper').outerHeight() - 75;
                this.cruiseConfiguratorArianeScene = new ScrollMagic.Scene({
                    triggerElement: '.module-configurateur-produit .wrapper',
                    triggerHook: 0,
                    duration: this.ScrollDuration,
                    offset: 0,
                })
                    .addTo(ScrollMagicGE.controller)
                    // .addIndicators() // add indicators (requires plugin)
                    .on('progress', (e) => {
                        $('.module-configurateur-produit .wrap-aside').css({
                            'transform': 'translateY(' + this.translateHeight(e.progress, this.ScrollDuration) + 'px)',
                            '-webkit-transform': 'translateY(' + this.translateHeight(e.progress, this.ScrollDuration) + 'px)',
                        });
                    })
                    .setClassToggle('.module-configurateur-produit .wrap-aside', 'fixed');

                $(window).bind('resizeEnd', () => this.updateDuration());
            },
            updateDuration: debounce(function () {
                this.ScrollDuration = $('.module-configurateur-produit .wrapper').outerHeight() - 75;
                this.cruiseConfiguratorArianeScene.duration(this.ScrollDuration);
            }, 500),
            translateHeight(progress, duration) {
                return (breakpointOnly('md') || breakpointOnly('sm')) ? (progress * duration) : 0;
            },
            ctaAfterStepChange() {
                this.updateDuration();
                // let offset = breakpointUp('lg') ? 130 : 20;
                Scrolling.scrollTo('.module-configurateur-produit .wrapper', 'easeInOutQuint', 500, 20);
            },
            startCountdown() {
                this.countdownId = setInterval(() => {
                    this.countdown--;
                    if (this.countdown === 0) {
                        this.stopCountdown();
                        window.location.assign(this.cartUrl);
                    }
                }, 1000);
            },
            stopCountdown() {
                if (this.countdownId) {
                    clearInterval(this.countdownId);
                }
            }

        },
        created() {
            if (this.$route.query.is_option === 'true') {
                this.submitted = true;
                this.optionSended = true;
            }
        },
        mounted() {
            setTimeout(() => {
                configuratorTopPosition = getTopPosition(this.$el.querySelector('.wrapper'));

                if (this.$route.query.is_option === 'true') {
                    this.saveCruiseToOption();
                }

            }, 500);
            window.addEventListener('resize', () => getTopPosition(this.$el.querySelector('.wrapper')));
            window.addEventListener('beforeunload', event => {
                if (leavingWarningActive) {
                    let text = 'Voulez vraiment quitter cette page ? Votre croisière ne sera pas sauvegardée.';
                    event.returnValue = text;
                    return text;
                }
            });
            this.cruiseConfiguratorAriane();
        },
    };
</script>


// WEBPACK FOOTER //
// assets/js/components/cruise-configurator/CruiseConfigurator.vue